import { Navigate, useLocation } from "react-router-dom";
import authService from "../services/auth/authService"; 

/**
 * `roles` (facultatif) : rôles admis sur la page. Les autres sont renvoyés vers
 * leur planning, page ouverte à tous. Confort seulement : le serveur refuse de
 * toute façon les données (core/permissions.py).
 */
function PrivateRoute({ children, roles }) {
  const location = useLocation();
  if (!authService.isAuthenticated()) {
    return <Navigate to="/" />;
  }
  // Mot de passe provisoire (accès créé par l'équipe) : à changer avant tout.
  if (authService.getCurrentUser()?.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (roles && !authService.hasRole(...roles)) {
    return <Navigate to="/planning" replace />;
  }
  return children;
}

export default PrivateRoute;
